export const ApiQueryKey = {
	products: 'products',
	productComponents: 'product-components',
	productTypes: 'product-types',

	admins: 'admins',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	content: 'content',
	components: 'components',
	productTypeVariants: 'product-type-variants',

	analytics: 'analytics',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
